import React from "react";
import Alert from "react-bootstrap/Alert";

export default function CustomAlert({ setShow, alertHeader, alertBody }) {
  return (
    <>
      <Alert variant="danger" onClose={() => setShow(false)} dismissible>
        <Alert.Heading>{alertHeader}</Alert.Heading>
        <p style={{ textAlign: "center" }}>{alertBody}</p>
      </Alert>
    </>
  );
}

//render(<CustomAlert/>);
